import * as React from 'react'
import {ErrorProps} from './ResidentHocInputErrorHandling'
import {createErrorHandlingForm, ErrorHandlingFormProps} from '../hoc/createResidentErrorHandlingForm'
import {CustomResidentTextFieldStyle} from '../../../../styledComponents/residentPage/TextField'
import styled from 'styled-components'
import {InputErrorProps} from '../../../../styledComponents/DisplayItem'
import {StyledDiv} from '../../../../styledComponents/StyledTypeDefinitions'
import {Colors} from '../../../../styledComponents/Constants'

interface Props {
    inputProps: React.TextareaHTMLAttributes<HTMLTextAreaElement>
    onChange?: (event: any, checked?: boolean) => void
    unitText?: string
}

export const TextAreaForResident = (props: Props & ErrorHandlingFormProps & ErrorProps) => {
    const {
        inputProps, hasError, clearErrorMessage, eventKeys,
        eventEmitter, errorAreaMaxWidth,
        unitText, ...rest
    } = props

    return <InputArea>
        <textarea
            {...inputProps}
            {...rest}
        />
        {
            unitText !== undefined &&
            <UnitTextArea>
                {unitText}
            </UnitTextArea>
        }
    </InputArea>
}
TextAreaForResident.displayName = 'PPTextAreaForResident'

const CustomTexAreaForResident = styled(TextAreaForResident)<InputErrorProps>`
   ${CustomResidentTextFieldStyle}
   height: 140px;
   padding: 15px;
   resize: none;
   ${props => props.unitText ? `padding-right: 35px` : ``};
`

const InputArea: StyledDiv = styled.div`
  display: flex;
  position: relative;
`

const UnitTextArea: StyledDiv = styled.div`
  color: ${Colors.AccentDark};
  margin-top: 13px;
  width: calc(100% - 10px);
  text-align: right;
  position: absolute;
  pointer-events: none;
`
export const PPTextAreaForResident = createErrorHandlingForm(CustomTexAreaForResident)